import styled from 'styled-components'

export const MyHighlightedText = {
    Section: styled.section`
        padding: 37px 0;
        
        @media (min-width: 768px) {
            padding: 60px 0;
        }
        
        @media (min-width: 1025px) {
            padding: 66px 0;
        }
    `,

    Header: styled.header`
        h2, p {
            margin: 0;
            font-size: 32px;
            line-height: 132%;            
        }
        
        @media (min-width: 768px) {
            max-width: 598px;

            h2, p {
                font-size: 40px;
            }
        }

        @media (min-width: 1025px) {
            h2, p {
                font-size: 48px;
            }
        }
    `,
    
    Wrapper: styled.article`
        max-width: 1480px;
        padding: 0 16px;
        margin: 0 16px;
        
        @media (min-width: 1025px) {
            padding: 0 20px;
            margin: 0 auto;
        }
    `,
    
    Title: styled.h2`
        font-family: 'Shell Heavy';
        color: #DD1D21;
    `,
    
    Subtitle: styled.p`
        font-family: 'Shell Book';
    `,
    
    Text: styled.p`
        font-family: 'Shell Book';
        line-height: 160%;
        font-size: 14px;
        margin-top: 20px;
        margin-bottom: 0;
        
        @media (min-width: 768px) {
            max-width: 992px;
        }

        @media (min-width: 1024px) {
            font-size: 18px;
        }
    `,
}